/* istanbul ignore file */
import { ComposedTheme, registerDefaultsForModule } from '@glu/theming';

const theme = ({ palette }: ComposedTheme) => ({
  backgroundColor: {
    primaryBackgroundColor: palette.highlightBackground,
  },
  color: {
    primaryColor: palette.text.dark,
    secondaryColor: palette.text.light,
  },
  pill: {
    color: palette.text.light,
    backgroundColor: palette.primary.veryDark,
  },
});

registerDefaultsForModule('badge', theme);

export default theme;
